/**
 * type: 全圆还是1/4圆 mobile：正常1/4圆fixed, pc全圆形,static。 special: 移动端1/4圆形fixed定位，pc下的缩小1/4圆static定位
 * disabled: 是否禁用
 * onClick: 点击事件
 * wrapperStyle: 外层容器的定位
 * style: 自定义内容的样式
 * text: 按钮展示的文字，可为字符串或者ReactNode
 * size: 接受large, middle, small, mini, 默认值是middle
 * */

import React from 'react'
import PropTypes from 'prop-types'
import IconDom from '../icon-dom'
import './index.scss'

function NextBtn (props) {
  const { type, size } = props
  const isType = (props) => {
    let className = ''
    switch (type) {
      case 'mobile':
        className = 'next-btn-wrapper'
        break
      case 'special':
        className = 'next-btn-special-wrapper'
        break
    }
    return className
  }
  return (
    <div className='next-btn-container clearfix' id='next-btn-container'>
      <div className='block-blank' />
      <div
        className={`${'next-btn-wrapper ' + isType()} ${size ? 'next-btn-wrapper-' + size : ''}`}
        style={{
          position: `${props.wrapperStyle.position || ''}`,
          bottom: `${props.wrapperStyle.bottom || '0'}`,
          right: `${props.wrapperStyle.right || '0'}`
        }}
      >
        <div className='next-btn-box p-relative' style={{ ...props.style }}>
          <div className='next-btn-content' onClick={props.disabled ? null : props.onClick} />
          <div className='next-btn-text'>
            {
              props.textLeft && <p
                className={'pr40 cursor-pointer btn-text-click-wrap ' + (props.leftBtnDisabled ? 'opacity' : null)}
                // style={{ display: 'inline-block' }}
                onClick={props.leftBtnDisabled ? null : props.onClickLeft}
              >
                <IconDom code={props.iconLeft || 'iconjiantou_you'} className='next-btn-arrow mt5' />
                <span className='props-text left-text'>{props.textLeft}</span>
              </p>
            }
            <p
              // style={{ display: 'inline-block' }}
              className={'cursor-pointer btn-text-click-wrap ' + (props.disabled ? 'opacity' : null)}
              onClick={props.disabled ? null : props.onClick}
            >
              <span className='props-text uw-btn-font'>{props.text}</span>
              <IconDom code={props.iconRight || 'iconjiantou_you'} className='next-btn-arrow' />
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

NextBtn.propTypes = {
  type: PropTypes.string,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  wrapperStyle: PropTypes.shape(),
  style: PropTypes.shape(),
  text: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
    PropTypes.node
  ])
}

NextBtn.defaultProps = {
  type: 'mobile',
  disabled: false,
  onClick: () => {},
  wrapperStyle: {},
  style: {},
  text: 'Next',
  size: ''
}

export default NextBtn
